<template>
    <div class="prop-button">
        {{ text }}
    </div>
</template>
  
<script>
export default {
    name: 'PropButton',
    props: ['text']
}
</script>
  
<style scoped>
.prop-button {
    background-color: #f5f5f5;
    color: #484D61;
    font-size: medium;
    height: 40px;
    width: 90%;
    margin-left: 5%;
    line-height: 40px;
    text-align: center;
    border-radius: 4px;
}
</style>
  